var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"distribution"},_vm._l((_vm.bands),function(band){return _c('div',{key:band.band,staticClass:"distribution-band",class:{'is-active': band.count > 0},style:({height: _vm.height(band.count)}),attrs:{"data-band":band.band}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }